
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M32 49.976l.22.014a1.75 1.75 0 11-.44 0l.22-.014zm12.132-25.544c.933 6.358-3.205 12.357-9.502 13.75a2.02 2.02 0 00-1.613 1.71l-.017.233v3.339a1 1 0 01-1.984.18l-.016-.18v-3.352a4.019 4.019 0 012.9-3.811l.32-.077a10.256 10.256 0 10-12.47-10 1 1 0 11-2 .003 12.256 12.256 0 0124.382-1.795z"}})])
          )
        }
      }
    